export const FETCH_MAILBOX = 'FETCH_MAILBOX'
export const FETCH_MAILBOX_SUCCESS = 'FETCH_MAILBOX_SUCCESS'
export const FETCH_MAILBOX_ERROR = 'FETCH_MAILBOX_ERROR'

export const FETCH_CARDS = 'FETCH_CARDS'
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS'
export const FETCH_CARDS_ERROR = 'FETCH_CARDS_ERROR'

export const FETCH_CONVERSATION = 'FETCH_CONVERSATION'
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS'
export const FETCH_CONVERSATION_ERROR = 'FETCH_CONVERSATION_ERROR'

export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR'

// maybe READ_CONVERSATION?
export const READ_MESSAGE = 'READ_MESSAGE'
export const READ_MESSAGE_SUCCESS = 'READ_MESSAGE_SUCCESS'
export const READ_MESSAGE_ERROR = 'READ_MESSAGE_ERROR'

export const DELETE_MESSAGE = 'DELETE_MESSAGE'
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS'
export const DELETE_MESSAGE_ERROR = 'DELETE_MESSAGE_ERROR'
